<template>
    <div id="teams" class="tabcontent tabcontent-border-style">
        <div class="table-container" v-if="teams.length > 0">
            <TableComponent :thead="thead" :tbody="teams" @update="updateTeam" @sort="SortTeam" :keys="keys"
                            model="teams" name="entity"
                            updateUrl="/settings/teams/edit"/>

            <div class="paginationLink">
                <pagination :data="laravelData" @pagination-change-page="getTeams" :limit="3">
                    <template #prev-nav><span>Previous</span></template>
                    <template #next-nav><span>Next</span></template>
                </pagination>
            </div>
        </div>

        <div v-else class="d-flex flex-column justify-content-center align-items-center gap-2 h-75 m-auto">
            <div class="h3Organization">
                <h3 v-if="!isSearchActive">You Don't Have Any Teams Yet</h3>
                <h3 v-else>No Data</h3>
            </div>
            <router-link class="text-decoration-none btn-container btn-container-no-data"
                         v-if="permissions.includes('create team') && teams.length === 0 && !isSearchActive"
                         to="/settings/teams/create">
                <span>Create Team</span>
            </router-link>
        </div>
    </div>
</template>

<script>
    import TableComponent from "../../components/TableComponent";
    import LaravelVuePagination from 'laravel-vue-pagination';
    import team from "../../../api-services/team";

    export default {
        name: 'setting-team',
        // 1. Accept Props from Parent
        props: ['globalSearch', 'globalSort'],
        data() {
            return {
                thead: ['Team Name', 'Number of Users', 'Leader'],
                keys: ['name', 'users_count' , 'user'],
                permissions: [],
                teams: [],
                originalTeams: [],
                laravelData: {},
                error: null,
                state: false,
            }
        },
        computed: {
            isSearchActive() {
                return this.globalSearch !== '';
            }
        },
        watch: {
            // 2. Watch Props to trigger API
            globalSearch(newVal) {
                this.getTeams(1);
            },
            globalSort(newVal) {
                this.getTeams(1);
            }
        },
        components: {
            TableComponent,
            'Pagination': LaravelVuePagination
        },
        async mounted() {
            await this.$store.dispatch('activeTap', 'settings');
            this.permissions = this.$store.state.auth.permissions;
            // Load initial data
            await this.getTeams();
        },
        methods: {
            async getTeams (page = 1) {
                try {
                    // 3. Use Props in API Call
                    const sortVal = this.globalSort !== '' ? this.globalSort : 'desc';
                    const response = await team.index(this.globalSearch, sortVal, true, page, true);

                    response.data.teams.data.forEach((team) => {
                        team['delateFlag'] = team.users_count > 0
                    });
                    
                    let filteredTeams = response.data.teams.data.filter(function(data){
                        return data.users_count != 0;
                    });
                    this.teams = filteredTeams;

                    if(this.teams.length > 0){
                        this.$emit('data-event', {'team': {action:true, search: this.isSearchActive}});
                    } else {
                        this.$emit('data-event', {'team': {action:false, search: this.isSearchActive}});
                    }

                    this.laravelData = response.data.teams;
                    this.originalTeams = response.data.teams.data;

                } catch (e) {
                    this.error = e;
                }
            },
            updateTeam(e) {
                let filteredData = this.teams.filter(function (data) {
                    return data.id != e;
                });
                this.teams = filteredData;
            },
            SortTeam() {
                // This is local sorting (clicking table headers), which is fine to keep local
                let status = !this.state;
                this.originalTeams.sort(function (a, b) {
                    return status ? -(a.id - b.id || a.name.localeCompare(b.name)) : -(b.id - a.id || b.name.localeCompare(a.name));
                });
                this.state = status;
            }
        }
    }
</script>

<style scoped>
    .table-container :deep(thead :first-child){
        width:30% !important;
    }
    .table-container :deep(thead :nth-child(2)){
        width:20% !important;
    }
    .table-container :deep(thead :nth-child(3)){
        width:35% !important;
    }
</style>


